import React from 'react';

const Brightness = ({ className }) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#B1B1B1" fillOpacity="0.22" />
            <circle className='ac-f' cx="23.0001" cy="23.0006" r="3.63636" fill="white" />
            <path className='ac-s' d="M23 15L23 17.1818" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M23 28.8184L23 31.0002" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M28.4214 17.1172L26.9428 18.7216" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M19.0571 27.2783L17.5785 28.8827" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M15 23L17.1818 23" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M28.8184 23L31.0002 23" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M17.1172 17.5781L18.7216 19.0567" stroke="white" strokeLinecap="round" />
            <path className='ac-s' d="M27.2783 26.9424L28.8827 28.421" stroke="white" strokeLinecap="round" />
        </svg>
    )
}

export default Brightness;